import Store from '@/shared/store'
import _get from 'lodash/get'
import Vue from 'vue'
import AclManager from './AclManager'

/*
 * `session.acls` already holds every right the user has, from their roles and
 * from the roles of their groups. So we do not check `roles` or `groups` any
 * more. Reading `acls` is enough.
 */
const effectiveAcls = session => {
  // The session is not loaded yet. Say no for now, the caller renders again later.
  if (!session) return {}
  // '*' means admin. It does not matter if the role came from the user or a group.
  if (session.acls === '*') return '*'
  // NOTE: old flag. Nothing sets it today. Kept just in case.
  if (session.isAdmin) return '*'
  return session.acls || {}
}

export default {
  install (app) {
    // Three levels, one per session:
    // 1. KING         -> example: $acl(true).can('core', 'storage_instance', 'create')
    // 2. Organization -> example: $acl(organizationId, organizationSession).can('projects', 'project', 'create')
    // 3. Project      -> example: $acl().can('dm', 'logical', 'read')
    // For storage engine rules, add the third argument:
    //                    example: $acl(organizationId, null, true).can('core', 'storage_instance', 'create')
    //
    // NOTE: the service and resource names must be the ones IAM sends in
    // `acls`. `GET /iam/v4/services_acls` lists them. There is no `core`
    // service: project rights are `projects:project:<action>`.
    //
    // NOTE: the first argument is not an organization id. Nothing reads its
    // value. `true` means "use the KING session". Anything else means "use the
    // session passed as second argument, or else the current one".
    // Levels 2 and 3 run the same code. Both are IAM sessions, and both carry
    // `acls` in the same shape.
    Vue.acl = app.config.globalProperties.$acl = (organizationId = null, forced_session = null, isStorageEngineCheck = null) => {
      // NOTE: KING_SESSION is only filled when the user logs in with forepaas
      // (see LOGIN_CMP in store/session.js). Under SSO it stays null, so level 1
      // says no to everything. That was already true before.
      const session = organizationId === true
        ? _get(Store, 'getters.KING_SESSION')
        : forced_session || _get(Store, 'getters.SESSION')
      const acls = effectiveAcls(session)

      // HACK: storage engine rules sit under the `storageengine` key, but every
      // call site asks for the `core` service. Move them so the calls match.
      // This works at all three levels now. Before, a first argument of `true`
      // made the plugin skip the flag, which broke FpSidebar outside core.
      if (isStorageEngineCheck) {
        return new AclManager(acls === '*' ? '*' : { core: acls.storageengine || [] })
      }

      return new AclManager(acls)
    }

    app.provide('$acl', app.config.globalProperties.$acl)
  }
}
